module.exports = __webpack_public_path__ + "static/media/Livre9.0a1785ce.png";